import request from '@/utils/request'
import https from '@/utils/https.js'
export function getAllLevel2(level1) {
    return https({
        url: '/api/special/getAllLevel2',
        method: 'post',
        data: {
            level1: level1,
        }
    })
}
export function getSpecialList(special_name,level1,level2,page) {
    return https({
        url: '/api/special/getSpecialList',
        method: 'post',
        data: {
            special_name: special_name,
            level1: level1,
            level2: level2,
            p: page,
        }
    })
}
export function getSpecialDetail(special_id) {
    return https({
        url: '/api/special/getSpecialDetail',
        method: 'post',
        data: {
            special_id: special_id,
        }
    })
}
export function getRelateSchool(special_id,page) {
    return https({
        url: '/api/special/getRelateSchool',
        method: 'post',
        data: {
            special_id: special_id,
            p: page,
        }
    })
}